module.exports = __webpack_public_path__ + "img/review-6.b0456fab.png";